import React, { useEffect } from 'react';
import { node, oneOfType, number, string } from 'prop-types';
import {
  extend, arrayOf, params, shape, string as stringType, useDataModel
} from '@thd-nucleus/data-sources';
import { StoreDetailsContext } from './StoreDetails.context';
import { StoreRecycleProgram } from './StoreRecycleProgram/StoreRecycleProgram';
import { StoreDetailsSEO } from './StoreDetailsSEO/StoreDetailsSEO';
import { HomeServicesSEO } from './HomeServices/HomeServicesSEO';
import { RentalSEO } from './Rentals/RentalSEO';

const StoreDetails = ({ children, storeId }) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('store-details.ready'); }, []);
  const contextValue = {
    storeId
  };
  return (
    <StoreDetailsContext.Provider value={contextValue}>
      {children}
    </StoreDetailsContext.Provider>

  );
};

StoreDetails.propTypes = {
  children: node.isRequired,
  storeId: oneOfType([string, number]).isRequired,
};

StoreDetails.displayName = 'StoreDetails';

StoreDetails.dataModel = extend({},
  StoreRecycleProgram,
  StoreDetailsSEO,
  HomeServicesSEO,
  RentalSEO
);

export { StoreDetails };
